import springCenfApi from '../../services/springCenfApi'

export const getFuturePayments = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/future_payments', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)